import { ContextStylesParams, CSSObject } from '@mantine/core'

const placeholderStyle = {
    color: 'var(--mantine-text-placeholder)'
}

const SIZES: Record<string, CSSObject> = {
    xs: { height: '3rem !important', '::placeholder': placeholderStyle },
    sm: { height: '3.6rem !important', '::placeholder': placeholderStyle },
    md: { height: '4.2rem !important', '::placeholder': placeholderStyle },
    lg: { height: '5rem !important', '::placeholder': placeholderStyle },
    xl: { height: '6rem !important', '::placeholder': placeholderStyle }
}

export const getSelectStyles = (props: ContextStylesParams): Record<string, CSSObject> => {
    const style = SIZES[props?.size] || {}

    return {
        input: {
            boxSizing: 'border-box !important'
        },
        rightSection: {
            width: '3.6rem',
            svg: {
                // TODO adjust icon size
                width: '1.8rem',
                height: '1.8rem'
            }
        }
    }
}
